module.exports = __webpack_public_path__ + "img/mc.d94ece34.svg";